var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cashflow-loader"},[_c('div',{staticClass:"header-text"},[_vm._v("סיימנו! המערכת בונה את התזרים הראשון שלך...")]),_vm._v(" "),_c('animated-loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }